export default "__VITE_ASSET__CdvMsyck__"